import { render, staticRenderFns } from "./OrdersListDialog.html?vue&type=template&id=ed72d7e2&scoped=true&"
import script from "./OrdersListDialog.js?vue&type=script&lang=js&"
export * from "./OrdersListDialog.js?vue&type=script&lang=js&"
import style0 from "./OrdersListDialog.scss?vue&type=style&index=0&id=ed72d7e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed72d7e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VDataTable,VPagination,VRow,VTab,VTabs})
